<template>
  <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
    <v-card-title>
      {{detalhe.foqnome}} <b v-if="detalhe.foqobrigatorio === 'S'" class="obrigatorio">*</b>
    </v-card-title>
    <v-card-subtitle>
      {{detalhe.foqdescricao}}
    </v-card-subtitle>
    <v-card-text>
      <v-select outlined placeholder="Escolha" :items="$$_opcoes"
      item-text="descricao"
      item-value="id"
      v-model="value"
      clearable>
      </v-select>

      <template v-if="(detalhe?.subquestoes?.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider ></v-divider>
            <component
            :is="subitem.foqtipo"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>

      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import errorHandler from '@/utils/error-handler';

export default {
  name: 'CardSelect',

  data() {
    return {
      value: null,
      alerta: false,
    };
  },

  methods: {
    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },
  },

  computed: {
    $$_opcoes() {
      return this.$props.detalhe.opcoes.map((opcao) => ({
        descricao: opcao.fqodescricao,
        id: opcao.id,
      }));
    },
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
  },

  mounted() {
    if (this.detalhe?.resposta) {
      const [res] = this.detalhe.resposta;
      this.value = res?.forresposta;
    }
  },

  props: {
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(valor) {
      if (valor) {
        this.alerta = false;
      }
    },
  },
};
</script>
/<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

    .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% {
      transform: translateX(10px);
    }

    25% {
      transform: translateX(-10px);
    }

    50% {
      transform: translateX(10px);
    }

    75% {
      transform: translateX(-10px);
    }

    100% {
      transform: translateX(0px);
    }
  }

</style>
